<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="partner_wrap container">
      <titleConfig
        class="partner_h2"
        :title="langSet == 'cn' ? '新闻中心' : 'News Center'"
        :type="2"
      ></titleConfig>
      <div class="flex flex_wrap">
        <news
          class="news_list"
          :type="1"
          v-for="(item, index) in list"
          :key="index"
          :newsData="item"
        ></news>
      </div>
      <nodata v-if="list.length == 0"></nodata>
      <div class="page_wrap flex flex_content_center">
        <el-pagination
          v-if="totals > 0"
          background
          layout="prev, pager, next"
          :total="totals"
          @current-change="currentChange"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import news from "@/components/news.vue";
import nodata from "@/components/nodata.vue";
import { articleList } from "@/api/api";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
    news,
    nodata,
  },
  data() {
    return {
      langSet: "",
      list: [{}],
      totals: 0,
      pageNo: 1,
      pageSize: 8,
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    //25.9.24 获取新闻资讯 dxm
    this.pageNo = 1;
    this.pageSize = 8;
    this.getList();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getList() {
      let data = {
        page_no: this.pageNo,
        page_size: this.pageSize,
        lang: this.langSet,
      };
      const res = await articleList(data);
      this.list = res.data.lists;
      console.log(this.list, '====list')
      this.totals = res.data.count;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getList();
    },
  },
};
</script>
<style lang="scss" >
.partner_wrap {
  padding: 80px 0;
  .partner_h2 {
    margin-bottom: 30px;
  }
  .news_list {
    width: calc((100% - 120px) / 4);
    margin-right: 40px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .news_item {
      margin-bottom: 30px;
    }
  }
}
.page_wrap {
  padding: 60px 0 0;
}
</style>
<style lang="scss" scoped>
@media only screen and (max-width: 1280px) {
  .partner_wrap .news_list {
    width: calc((100% - 6%) / 3);
    margin-right: 2%;
    &:nth-child(3n) {
      margin-right: 0;
    }
  }
}
@media only screen and (max-width: 767px) {
  .partner_wrap {
    padding: 0.58rem 0;
    .partner_h2 {
      margin-bottom: 0.38rem;
    }
    .news_list {
      width: 100%;
      margin-right: 0;
      .news_item {
        margin-bottom: 0.29rem;
      }
    }
  }
  .page_wrap {
    padding: 0.5rem 0 0.2rem;
  }
  /deep/ .el-pagination{
    width: 100%;
  }
}
</style>